<div fxFlex="0 0 400px" fxLayout="column" [formGroup]="form">
  <h4 matDialogTitle>Add Xero Account</h4>
  <mat-dialog-content>
    <mat-form-field class="w-full">
      <mat-label>Account Type</mat-label>
      <mat-select formControlName="type">
        <mat-option *ngIf="data?.type === 'BANK'" value="BANK">Bank</mat-option>
        <mat-option value="SALES">Sales</mat-option>
        <mat-option value="DIRECTCOSTS">Direct Costs</mat-option>
        <mat-option value="REVENUE">Revenue</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field class="w-full" *ngIf="form.get('type').value === 'BANK'">
      <input
        matInput
        placeholder="Bank Account Number"
        formControlName="bankAccountNumber"
      />
    </mat-form-field>
    <mat-form-field class="w-full">
      <input matInput placeholder="Name" formControlName="name" />
    </mat-form-field>
    <mat-form-field class="w-full">
      <input matInput placeholder="Code" formControlName="code" type="tel" />
    </mat-form-field>
    <mat-form-field class="w-full" *ngIf="form.get('type').value !== 'BANK'">
      <input matInput placeholder="Description" formControlName="description" />
    </mat-form-field>

    <p class="text-red-600" *ngIf="xeroError">
      An error occurred while trying to create your account. The response from
      Xero was: {{ xeroError }}
    </p>
  </mat-dialog-content>
  <div
    matDialogActions
    fxLayout="row"
    fxLayoutAlign="end center"
    fxLayoutGap="8px"
  >
    <button mat-raised-button (click)="dialogRef.close()" type="button">
      Cancel
    </button>
    <button
      mat-raised-button
      [disabled]="!accountMappingsForm?.valid"
      color="primary"
      (click)="submit()"
      id="save-account"
      type="submit"
    >
      Save Account
    </button>
  </div>
</div>
